import unzip from "unzip-js";

import { consoleLogError } from "./console";
import { FILES_DOWNLOAD_BOOK } from "@/shared/api/content/books/constants";
import { paraWithoutPrefixRegExp } from "@/shared/utils/content/content.constants";
import { makeChapterTree } from "@/shared/utils/content/content";
import { convertBook } from "@/shared/api/content/books/utils";

const scope = "ZIP";

export const parseZipBlob = (blob) => {
  return new Promise((resolve, reject) => {
    unzip(blob, function (err, zipFile) {
      if (err) {
        consoleLogError(scope, "unzip error", { err, zipFile });
        reject(err);
        return;
      }

      zipFile.readEntries(function (err, entries) {
        if (err) {
          consoleLogError(scope, "read entries error", { err, entries });
          reject(err);
          return;
        }

        const promisesEntriesParsing = [];

        entries.forEach(function (entry) {
          promisesEntriesParsing.push(new Promise((resolve, reject) => {
            zipFile.readEntryData(entry, false, function (err, readStream) {
              if (err) {
                consoleLogError(scope, "read entry data error", { err, readStream });
                reject(err);
                return;
              }

              let strEntryData = "";
              readStream.on("data", function (chunk) {
                strEntryData += chunk.toString();
              });

              readStream.on("error", (err) => {
                consoleLogError(scope, "read stream error", { err, readStream });
                reject([entry.name, err]);
              });
              readStream.on("end", () => {
                resolve([entry.name, strEntryData]);
              });
            });
          }));
        });

        Promise.all(promisesEntriesParsing).then(resolve);
      });
    });
  });
};

export const parseZipBookDownload = async (data) => {
  const entries = await parseZipBlob(data);

  const chaptersParas = {};
  let book, toc;

  for (const [filename, contents] of entries) {
    if (filename === FILES_DOWNLOAD_BOOK.BOOK) {
      book = JSON.parse(contents);
    } else if (filename === FILES_DOWNLOAD_BOOK.TOC) {
      toc = JSON.parse(contents);
    } else {
      if (filename) {
        const match = filename.match(paraWithoutPrefixRegExp);
        if (match && match[2]) {
          // match[2] - para number
          chaptersParas[match[2]] = JSON.parse(contents);
        }
      }
    }
  }

  return {
    book: convertBook(book),
    toc: makeChapterTree(toc).chapters,
    chaptersParas,
  };
};
